import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
} from "@ionic/angular";
import { ROUTE } from "../../../constant/routes";
import { STORAGE } from "../../../constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { errMsg } from "../../../text_control/error-msg";
import { TEXT } from "../../../text_control/index";
import { BTN } from "../../../text_control/text_button";
import { _getStorage, _setStorage } from "../../../utils/local-storage";

@Component({
  selector: "app-replace-savedata-taxinvoice",
  templateUrl: "./replace-savedata-taxinvoice.component.html",
  styleUrls: ["./replace-savedata-taxinvoice.component.scss"],
})
export class ReplaceSavedataTaxinvoiceComponent implements OnInit {
  email = "";
  datamodal: any;
  buyer_id: any;
  dataparam: any;
  Active: number;
  remark = "";
  text: any = {};
  textBTN: any = {};
  isShowBranchNo: any;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    public alertController: AlertController,
    public modalCtrl: ModalController,
    public router: Router,
    public apiservice: ApiserviceService,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public appservice: AppService,
    public route: ActivatedRoute
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.text = TEXT;
    this.textBTN = BTN;

    this.datamodal = navParams.get("data");
    this.buyer_id = navParams.get("buyer_id");
    this.email = navParams.get("email");
    this.isShowBranchNo = navParams.get("isShowBranchNo");
    this.remark = navParams.get("remark");
  }

  ngOnInit() {}

  async validateEmail() {
    const alert = await this.alertController.create({
      cssClass: "resend-confirm-email",
      header: errMsg.errorEmail,
      buttons: [
        {
          text: "OK",
          role: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  onDisableClick: boolean = false;
  async confirmWaitAlert() {
    if (this.email != "") {
      const re =
        /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) return this.validateEmail();
    }
    this.onDisableClick = true;

    setTimeout(async () => {
      await this.confirmAlert();
    }, 2000);
  }

  ionViewDidEnter() {
    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_replace") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 2;
      }
    });
  }

  async confirmAlert() {
    let data = {
      replace: {
        buyer_id: this.buyer_id,
        confirmreplace: "confirm",
        doctype: "1",
        email: this.email,
        remark: this.remark,
        isShowBranchNo: this.isShowBranchNo,
        taxinvoice_no: this.datamodal.taxinvoice_no,
        typeUpdate: this.datamodal.typeUpdate,
        typeUpdateDesc: this.datamodal.typeUpdateDesc,
        userBu: this.userBu,
        userLoc: this.userLoc,
        userRole: this.userRole,
        userSource: this.userSource,
        user_id: this.userID,
        mtrans_id: this.datamodal.mtrans_id,
      },
    };

    console.log("======= req confirm replace send email =========", data);
    try {
      this.apiservice
        ._post(this.apiservice.apiUrl + this.apiservice.confirmCreate, data)
        .then(async (res: any) => {
          console.log(
            "========== res confirm replace send email ========",
            res
          );
          this.dataparam = [];
          if (res.statusCode === 200) {
            this.dataparam.push(res.data);
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              header: errMsg.errorConfirmSendEmail,
            });

            await alert.present();
            setTimeout(() => {
              alert.dismiss(true);
              this.modalCtrl.dismiss({
                dismissed: true,
              });
              _setStorage(STORAGE.DATA_PREVIEW_REPLACE, this.dataparam);
              if (this.Active === 2) {
                this.router.navigate([ROUTE.REPLACE_PREVIEW]);
                this.appservice.setActive(5);
              } else {
                this.router.navigate([ROUTE.REPLACE_PREVIEW], {
                  queryParams: { noName: "no_replace", selectedIndex: "4" },
                });
                this.appservice.setActive(5);
              }
            }, 5000);
          } else {
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              header: res.statusMessage,
              buttons: [
                {
                  text: "OK",
                  cssClass: "alertButton",
                  handler: (blah) => {
                    this.onDisableClick = false;
                    this.modalCtrl.dismiss({ dismissed: true });
                  },
                },
              ],
            });
            await alert.present();
          }
        });
    } catch (error) {
      // this.ErrorMsg(errMsg.error);
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  dismiss() {
    this.appservice.setActive(3);
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }
}
